import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="recovery-code-download"
export default class extends Controller {
  static targets = ["source", "placeholder", "email"];

  #url;

  connect() {
    const file = new File(
      [
        `Raspberry Pi ID recovery code\n\nIf you lose your authenticator app, you can use the following recovery code to\nbypass two-factor authentication and sign in:\n\n  ${this.sourceTarget.innerText}\n\nEmail: ${this.emailTarget.value}\nGenerated: ${this.timestamp}`,
      ],
      this.filename,
      { type: "text/plain", endings: "native" },
    );

    this.#url = URL.createObjectURL(file);

    const link = document.createElement("a");
    link.href = this.#url;
    link.download = this.filename;
    link.className = "button button--primary";
    link.textContent = "Download";

    this.placeholderTarget.replaceWith(link);
  }

  disconnect() {
    URL.revokeObjectURL(this.#url);
  }

  get filename() {
    const localPart = this.emailTarget.value.split("@", 2)[0];
    const sanitizedLocalPart = localPart.replace(/\W/g, "-");

    return `raspberry-pi-id-recovery-code-${sanitizedLocalPart}.txt`;
  }

  get timestamp() {
    const now = new Date();

    return now.toISOString();
  }
}
